// extracted by mini-css-extract-plugin
export default {"container":"PrefixedInput_container__uSvMW","prefix":"PrefixedInput_prefix__EwmFx","postfix":"PrefixedInput_postfix__y-U+P","valueSizer":"PrefixedInput_valueSizer__NYXrq"};